import { SubPageShell } from "@/components/SubPageShell";
import { House } from "@/components/House";
import { Reveal } from "@/components/Reveal";

export default function TheHousePage() {
  return (
    <SubPageShell
      eyebrow="The House"
      title={<>Considered comfort, <em>stylishly Pacific.</em></>}
      intro="Five bedrooms, three bathrooms, an 8m pool and a designer kitchen that sits at the heart of the home. Every detail considered for slow island days."
    >
      <House hideHeader />

      {/* Floorplan */}
      <section className="py-24 md:py-32 bg-[hsl(var(--marble))]/40">
        <div className="container-editorial">
          <Reveal className="max-w-2xl mb-12">
            <div className="eyebrow-rule">Floor Plan</div>
            <h2 className="editorial-heading text-3xl md:text-4xl">
              The layout, <em>at a glance.</em>
            </h2>
            <p className="mt-5 text-[hsl(var(--muted-foreground))] max-w-xl text-[15px] leading-relaxed">
              Five bedrooms across a generous single-level floor plan — designed so every
              guest has space to spread out and find their own corner of the house.
            </p>
          </Reveal>
          <Reveal delay={80}>
            <div className="rounded-2xl overflow-hidden border border-[hsl(var(--border))] shadow-sm bg-white p-6 md:p-10">
              <img
                src="/images/floorplan.png"
                alt="Ata House Rarotonga floor plan"
                className="w-full h-auto"
                loading="lazy"
              />
            </div>
          </Reveal>
        </div>
      </section>
    </SubPageShell>
  );
}
